import { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Tooltip
} from '@mui/material';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from '@mui/material/TextField';
import LayerPanel from '../LayerPanel/LayerPanel';
import EditIcon from '@mui/icons-material/Edit';
import LayerQuickAccessButton from './LayerQuickAccessButtons';
import './LayerList.css';

const LayerAccordion = ({ layer, layerProps, index, layerCount, moveLayerUp, moveLayerDown, setLayerProps, map, styles }) => {

  const [panelExpanded, setPanelExpanded] = useState(false);
  const [titleEditing, setTitleEditing] = useState(false);
  const [title, setTitle] = useState(layerProps?.find(l => l.layerId === layer.id)?.layerTitle || (layer?.assetType === "gene_group" ? (layer?.title?.slice(0, 3)?.join('/') + (layer?.title?.length > 3 ? '...' : "")) : layer?.title));

  const handleAccodionExpansion = (layerId) => (event, isExpanded) => {
    // update expanded state
    const updatedLayerProps = layerProps.map(lv => {
      return {
        ...lv,
        expanded: lv.layerId === layerId ? isExpanded : lv.expanded
      };
    });
    setLayerProps(updatedLayerProps);
  };

  const handleEditLayerTitle = (event) => {
    event.stopPropagation();
    setTitleEditing(!titleEditing);
  }

  const handleTitleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setTitle(event.target.value);
      setTitleEditing(false);
      // update layer title
      const updatedLayerProps = layerProps.map(lv => {
        if (lv.layerId === layer.id) {
          return {
            ...lv,
            layerTitle: event.target.value
          };
        }
        return lv;
      });
      setLayerProps(updatedLayerProps);
    } else if (event.key === 'Escape') {
      setTitleEditing(false);
    }
  }

  const handleTitleBlur = () => {
    setTitleEditing(false);
  }

  const handleInteraction = (event) => {
    event.stopPropagation();
  }

  useEffect(() => {
    setPanelExpanded(layerProps.find(l => l.layerId === layer.id)?.expanded);
    const layerTitle = layerProps.find(l => l.layerId === layer.id)?.layerTitle;
    if (layerTitle !== title) {
      setTitle(layerTitle);
    }
  }, [layerProps]);

  return (
    <Accordion
      key={`accordion-${layer.id}`}
      className="layerAccordion"
      expanded={!!panelExpanded}
      onChange={handleAccodionExpansion(layer.id)}
    >
      <AccordionSummary
        className="accordion-summary"
        style={layerProps?.find(lv => lv.layerId === layer.id)?.visibility ? { opacity: 1 } : { opacity: 0.5 }}
        expandIcon={<ExpandMoreIcon />}>
        <div className="layerItem-container">
          <div className="layerItem-actionIcons">
            <ArrowDropUp
              onClick={index > 0 ? (event) => moveLayerUp(event, layer) : null}
              style={{
                cursor: index > 0 ? "pointer" : "default",
                opacity: index > 0 ? 1 : 0.5
              }}
            />
            <ArrowDropDown
              onClick={index < layerCount - 1 ? (event) => moveLayerDown(event, layer) : null}
              style={{
                cursor: index < layerCount - 1 ? "pointer" : "default",
                opacity: index < layerCount - 1 ? 1 : 0.5
              }}
            />
          </div>
          <div className="accordion-two-rows-content">
            <div className="accordion-first-row">
              {!titleEditing &&
                <Tooltip title="EDIT TITLE">
                  <Button
                    className="compactButton"
                    startIcon={<EditIcon />}
                    onClick={handleEditLayerTitle}>
                  </Button>
                </Tooltip>
              }
              {titleEditing ?
                <Tooltip title={layer?.title}>
                  <div className="layerItem-text">
                    {
                      <TextField
                        id="edit-title-text-field"
                        defaultValue={title}
                        variant="standard"
                        size='small'
                        autoFocus
                        onKeyDown={handleTitleKeyPress}
                        onBlur={handleTitleBlur}
                        onClick={handleInteraction}
                        onMouseDown={handleInteraction}
                        onFocus={handleInteraction}
                      />
                    }
                  </div>
                </Tooltip>
                : <Tooltip title={title}>
                  <div className="layerItem-text">
                    {title}
                  </div>
                </Tooltip>
              }
            </div>
            <div className="accordion-second-row">
              <div className="accordion-quick-access-buttons">
                <LayerQuickAccessButton
                  map={map}
                  layer={layer}
                  layerProps={layerProps}
                  setLayerProps={setLayerProps}
                  titleEditing={titleEditing}
                  setTitleEditing={setTitleEditing}
                />
              </div>
              <span className="layerType">{layer.assetType.replace("_", " ")}</span>
            </div>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className="accordion-details">
        <LayerPanel
          layer={layer}
          layerVisibility={layerProps.find(lv => lv.layerId === layer.id)?.visibility}
          layerExpanded={layerProps.find(lv => lv.layerId === layer.id)?.expanded}
          styles={styles}
          layerProps={layerProps}
          setLayerProps={setLayerProps}
        />
      </AccordionDetails>
    </Accordion>
  )
}

export default LayerAccordion;
